import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './NotFound.css'

export default function NotFound() {
  const navigate = useNavigate()
  const [count, setCount] = useState(10)

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((c) => {
        if (c <= 1) {
          clearInterval(timer)
          navigate('/')
          return 0
        }
        return c - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [navigate])

  return (
    <div className="nf">
      <div className="nf__bg" />
      <div className="nf__glow" />
      <div className="nf__grain" />

      <div className="nf__body">
        <div className="nf__num">404</div>

        <div className="nf__divider" />

        <p className="nf__label">Página não encontrada</p>

        <p className="nf__msg">
          A página que procura não existe ou foi movida.<br />
          Verifique o endereço ou regresse ao início.
        </p>

        <button className="nf__btn" onClick={() => navigate('/')}>
          Voltar ao início
        </button>

        <p className="nf__countdown">
          Redireccionamento automático em{' '}
          <span>{count}s</span>
        </p>
      </div>

      <div className="nf__logo" onClick={() => navigate('/')}>
        Mak<span>howo</span>
      </div>
    </div>
  )
}